import Container from '../../atoms/container/hourAndMinutesContainer';
import DateUtils from '../../../../shared/utils/date';
import Time from '../../atoms/text/playerTime';
import { HourAndMinutesProps as Props } from '../../../../shared/types/props/progressBar';

function HourAndMinutes({ position, live = false, value }: Props) {
  const isVod = !live;
  return (
    <Container position={position} live={live} id={'hourAndMinutesContainer'}>
      <Time id={'time'}>
        {value
          ? DateUtils.getTime({
              customDate: value,
              displaySeconds: isVod,
              utc: isVod,
            }) + (!isVod ? ' h' : '')
          : null}
      </Time>
    </Container>
  );
}

export default HourAndMinutes;
